import { Component } from '@angular/core';

@Component({
  selector: 'app-nav-logo',
  standalone: true,
  imports: [],
  templateUrl: './nav-logo.component.html',
  styleUrl: './nav-logo.component.css'
})
export class NavLogoComponent {

}
